const _ = "#fff7ed", e = "#ffedd5", o = "#fed7aa", n = "#fdba74", c = "#fb923c", s = "#f97316", t = "#ea580c", a = "#c2410c", f = "#9a3412", l = "#7c2d12", i = "#431407", r = "#fdf2f8", d = "#fce7f3", b = "#fbcfe8", m = "#f9a8d4", g = "#f472b6", y = "#ec4899", p = "#db2777", u = "#be185d", k = "#9d174d", h = "#831843", w = "#500724", v = "#fdf4ff", z = "#fae8ff", x = "#f5d0fe", S = "#f0abfc", j = "#e879f9", q = "#d946ef", A = "#c026d3", B = "#a21caf", C = "#86198f", D = "#701a75", E = "#4a044e", F = "#eff6ff", G = "#dbeafe", H = "#bfdbfe", I = "#93c5fd", J = "#60a5fa", K = "#3b82f6", L = "#2563eb", M = "#1d4ed8", N = "#1e40af", O = "#1e3a8a", P = "#172554", Q = "#f0fdfa", R = "#ccfbf1", T = "#99f6e4", U = "#5eead4", V = "#2dd4bf", W = "#14b8a6", X = "#0d9488", Y = "#0f766e", Z = "#115e59", $ = "#134e4a", _0 = "#042f2e", e0 = "#fef2f2", o0 = "#fee2e2", n0 = "#fecaca", c0 = "#fca5a5", s0 = "#f87171", t0 = "#ef4444", a0 = "#dc2626", f0 = "#b91c1c", l0 = "#991b1b", i0 = "#7f1d1d", r0 = "#450a0a", d0 = "#eafffe", b0 = "#cafffd", m0 = "#9cfffd", g0 = "#58feff", y0 = "#0ef2ff", p0 = "#00d4e9", u0 = "#00a8c3", k0 = "#017e94", h0 = "#0b6b7f", w0 = "#0e576b", v0 = "#023b4a", z0 = "#000", x0 = "#fff", S0 = "#f9fafb", j0 = "#f3f4f6", q0 = "#e5e7eb", A0 = "#d1d5db", B0 = "#9ca3af", C0 = "#6b7280", D0 = "#4b5563", E0 = "#374151", F0 = "#1f2937", G0 = "#111827", H0 = "#030712", I0 = "#f8fafc", J0 = "#f1f5f9", K0 = "#e2e8f0", L0 = "#cbd5e1", M0 = "#94a3b8", N0 = "#64748b", O0 = "#475569", P0 = "#334155", Q0 = "#1e293b", R0 = "#0f172a", T0 = "#020617", U0 = "#fff1f2", V0 = "#ffe4e6", W0 = "#fecdd3", X0 = "#fda4af", Y0 = "#fb7185", Z0 = "#f43f5e", $0 = "#e11d48", __ = "#be123c", e_ = "#9f1239", o_ = "#881337", n_ = "#4c0519", c_ = "#f0fdf4", s_ = "#dcfce7", t_ = "#bbf7d0", a_ = "#86efac", f_ = "#4ade80", l_ = "#22c55e", i_ = "#16a34a", r_ = "#15803d", d_ = "#166534", b_ = "#14532d", m_ = "#052e16", g_ = "#fefce8", y_ = "#fef9c3", p_ = "#fef08a", u_ = "#fde047", k_ = "#facc15", h_ = "#eab308", w_ = "#ca8a04", v_ = "#a16207", z_ = "#854d0e", x_ = "#713f12", S_ = "#422006", j_ = "#fdf4ff", q_ = "#fae8ff", A_ = "#f5d0fe", B_ = "#f0abfc", C_ = "#e879f9", D_ = "#d946ef", E_ = "#c026d3", F_ = "#a21caf", G_ = "#86198f", H_ = "#701a75", I_ = "#4a044e", J_ = "#f5f3ff", K_ = "#ede9fe", L_ = "#ddd6fe", M_ = "#c4b5fd", N_ = "#a78bfa", O_ = "#8b5cf6", P_ = "#7c3aed", Q_ = "#6d28d9", R_ = "#5b21b6", T_ = "#4c1d95", U_ = "#2d0a5b", V_ = "#eef2ff", W_ = "#e0e7ff", X_ = "#c7d2fe", Y_ = "#a5b4fc", Z_ = "#818cf8", $_ = "#6366f1", _e = "#4f46e5", ee = "#4338ca", oe = "#3730a3", ne = "#312e81", ce = "#1e1e3f", se = "#f0f9ff", te = "#e0f2fe", ae = "#bae6fd", fe = "#7dd3fc", le = "#38bdf8", ie = "#0ea5e9", re = "#0284c7", de = "#0369a1", be = "#075985", me = "#0c4a6e", ge = "#073c56", ye = "#ecfeff", pe = "#cffafe", ue = "#a5f3fc", ke = "#67e8f9", he = "#22d3ee", we = "#06b6d4", ve = "#0891b2", ze = "#0e7490", xe = "#155e75", Se = "#164e63", je = "#0f364b", qe = "#ecfdf5", Ae = "#d1fae5", Be = "#a7f3d0", Ce = "#6ee7b7", De = "#34d399", Ee = "#10b981", Fe = "#059669", Ge = "#047857", He = "#065f46", Ie = "#064e3b", Je = "#022c22", Ke = "#f7fee7", Le = "#ecfccb", Me = "#d9f99d", Ne = "#bef264", Oe = "#a3e635", Pe = "#84cc16", Qe = "#65a30d", Re = "#4d7c0f", Te = "#3f6212", Ue = "#365314", Ve = "#1f2f0b", We = "#fffbeb", Xe = "#fef3c7", Ye = "#fde68a", Ze = "#fcd34d", $e = "#fbbf24", _o = "#f59e0b", eo = "#d97706", oo = "#b45309", no = "#92400e", co = "#78350f", so = "#451a03", to = "#f8f8f8", ao = "#f5f5f4", fo = "#e7e5e4", lo = "#d6d3d1", io = "#a8a29e", ro = "#78716c", bo = "#57534e", mo = "#44403c", go = "#292524", yo = "#1c1917", po = "#0c0a09", uo = "#fafafa", ko = "#f4f4f5", ho = "#e4e4e7", wo = "#d4d4d8", vo = "#a1a1aa", zo = "#71717a", xo = "#52525b", So = "#3f3f46", jo = "#27272a", qo = "#18181b", Ao = "#09090b", Bo = "#f9fafb", Co = "#f3f4f6", Do = "#e5e7eb", Eo = "#d1d5db", Fo = "#9ca3af", Go = "#6b7280", Ho = "#4b5563", Io = "#374151", Jo = "#1f2937", Ko = "#111827", Lo = "#030712", Mo = {
  orange_50: _,
  orange_100: e,
  orange_200: o,
  orange_300: n,
  orange_400: c,
  orange_500: s,
  orange_600: t,
  orange_700: a,
  orange_800: f,
  orange_900: l,
  orange_950: i,
  pink_50: r,
  pink_100: d,
  pink_200: b,
  pink_300: m,
  pink_400: g,
  pink_500: y,
  pink_600: p,
  pink_700: u,
  pink_800: k,
  pink_900: h,
  pink_950: w,
  purple_50: v,
  purple_100: z,
  purple_200: x,
  purple_300: S,
  purple_400: j,
  purple_500: q,
  purple_600: A,
  purple_700: B,
  purple_800: C,
  purple_900: D,
  purple_950: E,
  blue_50: F,
  blue_100: G,
  blue_200: H,
  blue_300: I,
  blue_400: J,
  blue_500: K,
  blue_600: L,
  blue_700: M,
  blue_800: N,
  blue_900: O,
  blue_950: P,
  teal_50: Q,
  teal_100: R,
  teal_200: T,
  teal_300: U,
  teal_400: V,
  teal_500: W,
  teal_600: X,
  teal_700: Y,
  teal_800: Z,
  teal_900: $,
  teal_950: _0,
  red_50: e0,
  red_100: o0,
  red_200: n0,
  red_300: c0,
  red_400: s0,
  red_500: t0,
  red_600: a0,
  red_700: f0,
  red_800: l0,
  red_900: i0,
  red_950: r0,
  ist_50: d0,
  ist_100: b0,
  ist_200: m0,
  ist_300: g0,
  ist_400: y0,
  ist_500: p0,
  ist_600: u0,
  ist_700: k0,
  ist_800: h0,
  ist_900: w0,
  ist_950: v0,
  mono_black: z0,
  mono_white: x0,
  mono_50: S0,
  mono_100: j0,
  mono_200: q0,
  mono_300: A0,
  mono_400: B0,
  mono_500: C0,
  mono_600: D0,
  mono_700: E0,
  mono_800: F0,
  mono_900: G0,
  mono_950: H0,
  slate_50: I0,
  slate_100: J0,
  slate_200: K0,
  slate_300: L0,
  slate_400: M0,
  slate_500: N0,
  slate_600: O0,
  slate_700: P0,
  slate_800: Q0,
  slate_900: R0,
  slate_950: T0,
  rose_50: U0,
  rose_100: V0,
  rose_200: W0,
  rose_300: X0,
  rose_400: Y0,
  rose_500: Z0,
  rose_600: $0,
  rose_700: __,
  rose_800: e_,
  rose_900: o_,
  rose_950: n_,
  green_50: c_,
  green_100: s_,
  green_200: t_,
  green_300: a_,
  green_400: f_,
  green_500: l_,
  green_600: i_,
  green_700: r_,
  green_800: d_,
  green_900: b_,
  green_950: m_,
  yellow_50: g_,
  yellow_100: y_,
  yellow_200: p_,
  yellow_300: u_,
  yellow_400: k_,
  yellow_500: h_,
  yellow_600: w_,
  yellow_700: v_,
  yellow_800: z_,
  yellow_900: x_,
  yellow_950: S_,
  fuchsia_50: j_,
  fuchsia_100: q_,
  fuchsia_200: A_,
  fuchsia_300: B_,
  fuchsia_400: C_,
  fuchsia_500: D_,
  fuchsia_600: E_,
  fuchsia_700: F_,
  fuchsia_800: G_,
  fuchsia_900: H_,
  fuchsia_950: I_,
  violet_50: J_,
  violet_100: K_,
  violet_200: L_,
  violet_300: M_,
  violet_400: N_,
  violet_500: O_,
  violet_600: P_,
  violet_700: Q_,
  violet_800: R_,
  violet_900: T_,
  violet_950: U_,
  indigo_50: V_,
  indigo_100: W_,
  indigo_200: X_,
  indigo_300: Y_,
  indigo_400: Z_,
  indigo_500: $_,
  indigo_600: _e,
  indigo_700: ee,
  indigo_800: oe,
  indigo_900: ne,
  indigo_950: ce,
  sky_50: se,
  sky_100: te,
  sky_200: ae,
  sky_300: fe,
  sky_400: le,
  sky_500: ie,
  sky_600: re,
  sky_700: de,
  sky_800: be,
  sky_900: me,
  sky_950: ge,
  cyan_50: ye,
  cyan_100: pe,
  cyan_200: ue,
  cyan_300: ke,
  cyan_400: he,
  cyan_500: we,
  cyan_600: ve,
  cyan_700: ze,
  cyan_800: xe,
  cyan_900: Se,
  cyan_950: je,
  emerald_50: qe,
  emerald_100: Ae,
  emerald_200: Be,
  emerald_300: Ce,
  emerald_400: De,
  emerald_500: Ee,
  emerald_600: Fe,
  emerald_700: Ge,
  emerald_800: He,
  emerald_900: Ie,
  emerald_950: Je,
  lime_50: Ke,
  lime_100: Le,
  lime_200: Me,
  lime_300: Ne,
  lime_400: Oe,
  lime_500: Pe,
  lime_600: Qe,
  lime_700: Re,
  lime_800: Te,
  lime_900: Ue,
  lime_950: Ve,
  amber_50: We,
  amber_100: Xe,
  amber_200: Ye,
  amber_300: Ze,
  amber_400: $e,
  amber_500: _o,
  amber_600: eo,
  amber_700: oo,
  amber_800: no,
  amber_900: co,
  amber_950: so,
  stone_50: to,
  stone_100: ao,
  stone_200: fo,
  stone_300: lo,
  stone_400: io,
  stone_500: ro,
  stone_600: bo,
  stone_700: mo,
  stone_800: go,
  stone_900: yo,
  stone_950: po,
  zinc_50: uo,
  zinc_100: ko,
  zinc_200: ho,
  zinc_300: wo,
  zinc_400: vo,
  zinc_500: zo,
  zinc_600: xo,
  zinc_700: So,
  zinc_800: jo,
  zinc_900: qo,
  zinc_950: Ao,
  gray_50: Bo,
  gray_100: Co,
  gray_200: Do,
  gray_300: Eo,
  gray_400: Fo,
  gray_500: Go,
  gray_600: Ho,
  gray_700: Io,
  gray_800: Jo,
  gray_900: Ko,
  gray_950: Lo
};
export {
  Xe as amber_100,
  Ye as amber_200,
  Ze as amber_300,
  $e as amber_400,
  We as amber_50,
  _o as amber_500,
  eo as amber_600,
  oo as amber_700,
  no as amber_800,
  co as amber_900,
  so as amber_950,
  G as blue_100,
  H as blue_200,
  I as blue_300,
  J as blue_400,
  F as blue_50,
  K as blue_500,
  L as blue_600,
  M as blue_700,
  N as blue_800,
  O as blue_900,
  P as blue_950,
  pe as cyan_100,
  ue as cyan_200,
  ke as cyan_300,
  he as cyan_400,
  ye as cyan_50,
  we as cyan_500,
  ve as cyan_600,
  ze as cyan_700,
  xe as cyan_800,
  Se as cyan_900,
  je as cyan_950,
  Mo as default,
  Ae as emerald_100,
  Be as emerald_200,
  Ce as emerald_300,
  De as emerald_400,
  qe as emerald_50,
  Ee as emerald_500,
  Fe as emerald_600,
  Ge as emerald_700,
  He as emerald_800,
  Ie as emerald_900,
  Je as emerald_950,
  q_ as fuchsia_100,
  A_ as fuchsia_200,
  B_ as fuchsia_300,
  C_ as fuchsia_400,
  j_ as fuchsia_50,
  D_ as fuchsia_500,
  E_ as fuchsia_600,
  F_ as fuchsia_700,
  G_ as fuchsia_800,
  H_ as fuchsia_900,
  I_ as fuchsia_950,
  Co as gray_100,
  Do as gray_200,
  Eo as gray_300,
  Fo as gray_400,
  Bo as gray_50,
  Go as gray_500,
  Ho as gray_600,
  Io as gray_700,
  Jo as gray_800,
  Ko as gray_900,
  Lo as gray_950,
  s_ as green_100,
  t_ as green_200,
  a_ as green_300,
  f_ as green_400,
  c_ as green_50,
  l_ as green_500,
  i_ as green_600,
  r_ as green_700,
  d_ as green_800,
  b_ as green_900,
  m_ as green_950,
  W_ as indigo_100,
  X_ as indigo_200,
  Y_ as indigo_300,
  Z_ as indigo_400,
  V_ as indigo_50,
  $_ as indigo_500,
  _e as indigo_600,
  ee as indigo_700,
  oe as indigo_800,
  ne as indigo_900,
  ce as indigo_950,
  b0 as ist_100,
  m0 as ist_200,
  g0 as ist_300,
  y0 as ist_400,
  d0 as ist_50,
  p0 as ist_500,
  u0 as ist_600,
  k0 as ist_700,
  h0 as ist_800,
  w0 as ist_900,
  v0 as ist_950,
  Le as lime_100,
  Me as lime_200,
  Ne as lime_300,
  Oe as lime_400,
  Ke as lime_50,
  Pe as lime_500,
  Qe as lime_600,
  Re as lime_700,
  Te as lime_800,
  Ue as lime_900,
  Ve as lime_950,
  j0 as mono_100,
  q0 as mono_200,
  A0 as mono_300,
  B0 as mono_400,
  S0 as mono_50,
  C0 as mono_500,
  D0 as mono_600,
  E0 as mono_700,
  F0 as mono_800,
  G0 as mono_900,
  H0 as mono_950,
  z0 as mono_black,
  x0 as mono_white,
  e as orange_100,
  o as orange_200,
  n as orange_300,
  c as orange_400,
  _ as orange_50,
  s as orange_500,
  t as orange_600,
  a as orange_700,
  f as orange_800,
  l as orange_900,
  i as orange_950,
  d as pink_100,
  b as pink_200,
  m as pink_300,
  g as pink_400,
  r as pink_50,
  y as pink_500,
  p as pink_600,
  u as pink_700,
  k as pink_800,
  h as pink_900,
  w as pink_950,
  z as purple_100,
  x as purple_200,
  S as purple_300,
  j as purple_400,
  v as purple_50,
  q as purple_500,
  A as purple_600,
  B as purple_700,
  C as purple_800,
  D as purple_900,
  E as purple_950,
  o0 as red_100,
  n0 as red_200,
  c0 as red_300,
  s0 as red_400,
  e0 as red_50,
  t0 as red_500,
  a0 as red_600,
  f0 as red_700,
  l0 as red_800,
  i0 as red_900,
  r0 as red_950,
  V0 as rose_100,
  W0 as rose_200,
  X0 as rose_300,
  Y0 as rose_400,
  U0 as rose_50,
  Z0 as rose_500,
  $0 as rose_600,
  __ as rose_700,
  e_ as rose_800,
  o_ as rose_900,
  n_ as rose_950,
  te as sky_100,
  ae as sky_200,
  fe as sky_300,
  le as sky_400,
  se as sky_50,
  ie as sky_500,
  re as sky_600,
  de as sky_700,
  be as sky_800,
  me as sky_900,
  ge as sky_950,
  J0 as slate_100,
  K0 as slate_200,
  L0 as slate_300,
  M0 as slate_400,
  I0 as slate_50,
  N0 as slate_500,
  O0 as slate_600,
  P0 as slate_700,
  Q0 as slate_800,
  R0 as slate_900,
  T0 as slate_950,
  ao as stone_100,
  fo as stone_200,
  lo as stone_300,
  io as stone_400,
  to as stone_50,
  ro as stone_500,
  bo as stone_600,
  mo as stone_700,
  go as stone_800,
  yo as stone_900,
  po as stone_950,
  R as teal_100,
  T as teal_200,
  U as teal_300,
  V as teal_400,
  Q as teal_50,
  W as teal_500,
  X as teal_600,
  Y as teal_700,
  Z as teal_800,
  $ as teal_900,
  _0 as teal_950,
  K_ as violet_100,
  L_ as violet_200,
  M_ as violet_300,
  N_ as violet_400,
  J_ as violet_50,
  O_ as violet_500,
  P_ as violet_600,
  Q_ as violet_700,
  R_ as violet_800,
  T_ as violet_900,
  U_ as violet_950,
  y_ as yellow_100,
  p_ as yellow_200,
  u_ as yellow_300,
  k_ as yellow_400,
  g_ as yellow_50,
  h_ as yellow_500,
  w_ as yellow_600,
  v_ as yellow_700,
  z_ as yellow_800,
  x_ as yellow_900,
  S_ as yellow_950,
  ko as zinc_100,
  ho as zinc_200,
  wo as zinc_300,
  vo as zinc_400,
  uo as zinc_50,
  zo as zinc_500,
  xo as zinc_600,
  So as zinc_700,
  jo as zinc_800,
  qo as zinc_900,
  Ao as zinc_950
};
